export default __webpack_public_path__ + "static/media/attach-24dp.bcde288d.svg";